import { mapGetters } from 'vuex';
import { MEDIA } from '@/helpers/variables';

export default {
  name: 'HomeCosmetologist',
  components: {},
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      MEDIA
    };
  },
  created() {},
  mounted() {},
  computed: {
    ...mapGetters({
      appSize: 'app/size'
    })
  },
  methods: {}
};
